import React from "react";
import './AnimatedLink.scss'
import {NavLink} from "react-router-dom";

function AnimatedLink({content, href}: {content: any, href: string}) {
    return <NavLink className={({ isActive }) => (isActive ? "wilmaplus-animated-link-selected" : "wilmaplus-animated-link")} to={href}>{content}</NavLink>
}

export default AnimatedLink;